import { render, staticRenderFns } from "./Courierservice.vue?vue&type=template&id=517c9e09"
import script from "./Courierservice.vue?vue&type=script&lang=js"
export * from "./Courierservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports